import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { useLocation, useSearchParams } from 'react-router-dom';

import { View } from '../Base';
import {
  PLEASE_CLICK,
  SHOW_SELECTED_ROUTE,
  TO_SEE_MORE,
} from '../../constants/strings';
import palette from '../styles/palette';
import Button from '../Button';
import { parseQuery } from '../../utils/query';
import { setStopMarkerPopup } from '../../store/reducers/map';

const useStyles = makeStyles({
  button: {
    color: palette.pictonBlue,
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16px',
    padding: '0',
    height: 'auto',
    minWidth: 'auto',
    margin: '0 5px',
  },
  text: {
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16px',
  },
});

const GoToRouteDetailsWarning = ({ warningText }) => {
  const styles = useStyles();
  const [, setSearchParams] = useSearchParams();
  const location = useLocation();
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    const query = parseQuery(location.search);
    if (!query.detailVisible) {
      dispatch(setStopMarkerPopup(null));
    }
    setSearchParams({
      ...query,
      detailVisible: true,
    });
  }, [dispatch, location.search, setSearchParams]);

  return (
    <View className={styles.text}>
      <View>{warningText}</View>
      <span>{PLEASE_CLICK}</span>
      <Button variant="text" className={styles.button} onClick={onClick}>
        {SHOW_SELECTED_ROUTE}
      </Button>
      <span>{TO_SEE_MORE}</span>
    </View>
  );
};

export default memo(GoToRouteDetailsWarning);
